import { WindowCooldownConfig } from "../api/trade-to-earn/trade-to-earn-rules";
import { Any } from "../fakeTypes";

export function hasWindowCooldown(data: Any): data is { cooldown: WindowCooldownConfig } {
  return data.cooldown !== undefined;
}
